import React, { useState } from 'react';
import Sidebar from '../sidebar/Sidebar';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import numberPlateLogo from '../../assets/croped logo.png';

const SIDEBAR_WIDTH = 260;

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen((open) => !open);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="dashboard-shell">
      <div className="number-plate-logo" aria-hidden="true">
        <img src={numberPlateLogo} alt="Ledger Glide logo" />
      </div>
      {/* Sidebar (desktop) */}
      <aside className="sidebar-desktop">
        <Sidebar isMobile={false} />
      </aside>

      {/* Sidebar (mobile drawer) */}
      <aside className={`sidebar-mobile-drawer${sidebarOpen ? ' open' : ''}`}>
        <Sidebar isOpen={sidebarOpen} toggleSidebar={closeSidebar} onNavigate={closeSidebar} isMobile={true} />
      </aside>
      {sidebarOpen && <div className="sidebar-mobile-backdrop" onClick={closeSidebar}></div>}

      {/* Main content */}
      <div className="main-area">
        {/* Mobile header */}
        <div className="mobile-header">
          <button className="mobile-menu-btn" onClick={toggleSidebar} aria-label="Open sidebar">
            <Menu size={24} />
          </button>
          <span className="mobile-title">Dashboard</span>
        </div>
        <div className="main-content">
          <Outlet />
        </div>
      </div>

      <style>{`
        .dashboard-shell {
          display: flex;
          min-height: 100vh;
          width: 100vw;
          background: #fafbfc;
          position: relative;
        }
        .sidebar-desktop {
          display: none;
        }
        .sidebar-mobile-drawer {
          display: none;
        }
        .sidebar-mobile-backdrop {
          display: none;
        }
        .main-area {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          margin-left: 0 !important;
          padding: 0 !important;
        }
        .mobile-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem;
          background: #fff;
          border-bottom: 1px solid #e5e7eb;
          box-shadow: 0 1px 3px 0 rgba(0,0,0,0.04);
        }
        .mobile-menu-btn {
          background: none;
          border: none;
          color: #374151;
          padding: 0.5rem;
          border-radius: 0.5rem;
          cursor: pointer;
        }
        .mobile-title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #1f2937;
        }
        .main-content {
          flex: 1;
          min-width: 0;
          width: 100%;
          margin: 0 !important;
          padding: 0 !important;
        }
        .number-plate-logo {
          position: fixed;
          top: 16px;
          right: 24px;
          // background: #fff;
          padding: 8px 16px;
          // border-radius: 10px;
          // border: 1px solid #e5e7eb;
          // box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          z-index: 110;
          max-width: 400px;
        }
        .number-plate-logo img {
          height: 80px;
          width: auto;
          object-fit: contain;
          display: block;
        }
        @media (min-width: 992px) {
          .sidebar-desktop {
            display: block;
            width: ${SIDEBAR_WIDTH}px;
            min-width: ${SIDEBAR_WIDTH}px;
            max-width: ${SIDEBAR_WIDTH}px;
            height: 100vh;
            position: sticky;
            top: 0;
            left: 0;
            z-index: 100;
            background: #fff;
          }
          .sidebar-mobile-drawer, .sidebar-mobile-backdrop, .mobile-header {
            display: none !important;
          }
          .main-area {
            margin-left: 0 !important;
            padding: 0 !important;
          }
        }
        @media (max-width: 991.98px) {
          .sidebar-desktop {
            display: none;
          }
          .sidebar-mobile-drawer {
            display: block;
            position: fixed;
            top: 0;
            left: 0;
            height: 100vh;
            width: 80vw;
            max-width: 320px;
            z-index: 1200;
            background: #fff;
            box-shadow: 2px 0 16px rgba(0,0,0,0.08);
            transform: translateX(-100%);
            transition: transform 0.3s cubic-bezier(0.4,0,0.2,1);
          }
          .sidebar-mobile-drawer.open {
            transform: translateX(0);
          }
          .sidebar-mobile-backdrop {
            display: block;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.3);
            z-index: 1199;
          }
          .main-area {
            margin-left: 0 !important;
            padding: 0 !important;
          }
          .mobile-header {
            display: flex;
          }
          .number-plate-logo {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default DashboardLayout; 